"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreakPoint = void 0;
var react_1 = __importDefault(require("react"));
var hooks_1 = require("../../hooks/");
exports.BreakPoint = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, max = _a.max, min = _a.min, props = __rest(_a, ["children", "max", "min"]);
    var maxWidthState;
    var minWidthState;
    var screensize = hooks_1.useScreenSize();
    if (typeof max !== 'number') {
        maxWidthState = !max;
        Object.keys(screensize.smallerThan).forEach(function (maxWidthBP) {
            if (max === maxWidthBP && screensize.smallerThan[max]) {
                maxWidthState = true;
            }
        });
    }
    else {
        maxWidthState =
            screensize.innerWidth <= max ? true : false || max <= 0;
    }
    if (typeof min !== 'number') {
        minWidthState = !min;
        Object.keys(screensize.largerThan).forEach(function (minWidthBP) {
            if (min === minWidthBP && screensize.largerThan[min]) {
                minWidthState = true;
            }
        });
    }
    else {
        minWidthState =
            screensize.innerWidth > min ? true : false || min <= 0;
    }
    if (maxWidthState && minWidthState) {
        return (react_1.default.createElement("div", __assign({ ref: ref }, props), children));
    }
    return null;
});
//# sourceMappingURL=BreakPoint.js.map